module.exports = __webpack_public_path__ + "img/form-header-bg.6747882.jpg";